
export const PRIORITY_ITEMS = ['Low', 'Normal', 'High'];
export const STATUS_ITEMS = ['Open', 'In Progress', 'Deferred', 'Completed'];

export const STROKE_MAP = {
	FREESTYLE: 1,
	BACKSTROKE: 2,
	BREASTSTROKE: 3,
	BUTTERFLY: 4,
	MEDLEY: 5,
};

export const STROKE_LOOKUP = [
	{ id: 1, name: 'Freistil' },
	{ id: 2, name: 'Rücken' },
	{ id: 3, name: 'Brust' },
	{ id: 4, name: 'Schmetterling' },
	{ id: 5, name: 'Lagen' },
];

export const GENDER_MAP = {
	MALE: 1,
	FEMALE: 2,
	MIXED: 3,
};

export const GENDER_LOOKUP = [
	{ id: 1, name: 'Männlich' },
	{ id: 2, name: 'Weiblich' },
	{ id: 3, name: 'Mixed' },
];

export const ROUND_MAP = {
	TIM: 1, // Time final
	FIN: 2, // Final
	SEM: 3, // Semifinal
	QUA: 4, // Qualification
	HEA: 4, // Heats/Qualification
};

export const ROUND_LOOKUP = [
	{ id: 1, name: 'Zeitendlauf' },
	{ id: 2, name: 'Finale' },
	{ id: 3, name: 'Halbfinale' },
	{ id: 4, name: 'Vorlauf' },
];

export function mapValue(map, value, fallback = null) {
	if (!value) return fallback;
	return map[value.toUpperCase()] ?? fallback;
}
